const myStorage = {
    set(key, value) {
        localStorage.setItem(key, JSON.stringify(value));
    },
    get(key) {
        try {
            const value = localStorage.getItem(key);
            if (value === null || value === undefined || value === "") {
                return null;
            }
            return JSON.parse(localStorage.getItem(key));
        } catch (err) {
            return null;
        }
    },
    remove(key) {
        localStorage.removeItem(key);
    },
};
const mySession = {
    set(key, value) {
        sessionStorage.setItem(key, JSON.stringify(value));
    },
    get(key) {
        try {
            const value = sessionStorage.getItem(key);
            if (value === null || value === undefined || value === "") {
                return null;
            }
            return JSON.parse(sessionStorage.getItem(key));
        } catch (err) {
            return null;
        }
    },
    remove(key) {
        sessionStorage.removeItem(key);
    },
};

function filter4Hours(value) {
    return value % (4 * 60) ? 0 : 1;
}

function padZero(timeStr) {
    if (timeStr.length != 8) {
        timeStr = '0'.concat(timeStr);
    }
    return timeStr.slice(0, 5);
}

function findMaxSegment(startTimes, endTimes, min, max) {
    var ret = [];
    if (endTimes.length == 1) {
        ret.push({
            span: (24 * 60 - unformatTime(endTimes[0])),
            segment: {
                te: max,
                ts: unformatTime(endTimes[0])
            }
        });
        return ret;
    }
    for (var i = 0; i < startTimes.length; i++) {
        var temp = {};
        temp.ts = unformatTime(endTimes[i]);
        temp.te = startTimes[i + 1] ? unformatTime(startTimes[i + 1]) : max;
        ret.push({
            span: temp.te - temp.ts,
            segment: temp
        });
    }
    ret.sort(function (a, b) {
        return b.span - a.span
    });
    return ret;
}
function unformatTime(str) {
    var timeArray = str.split(':'),
    minutes = 0;
    minutes = minutes + (Number(timeArray[0]) * 60);
    minutes = minutes + Number(timeArray[1]);
    return Number(minutes);
}
function formatTime(value) {
    var hours = Math.floor(value / 60),
        minutes = Math.floor((value - (hours * 60)))
    return (hours < 10 ? '0' + hours : hours) + ':' + (minutes < 10 ? '0' + minutes : minutes);
}
var timeFormator = {
    to: function (value) {
        return formatTime(value);
    }
}
export { myStorage, mySession, unformatTime, formatTime, timeFormator, filter4Hours, findMaxSegment, padZero };